import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import i18n from "i18next";

interface PeriodState {
  date: string;
}

const initialState: PeriodState = {
  date: "Derniers 30 jours", // i18n.t("The last 30 days")
};

export const periodSlice = createSlice({
  name: "periodSlice",
  initialState,
  reducers: {
    changePeriod(state, action: PayloadAction<string>) {
      state.date = action.payload;
    },

    clearPeriod(state) {
      state.date = i18n.t("The last 30 days");
    },

    translatePeriod(state, action: PayloadAction<string>) {
      let period = action.payload;
      if (period === "Semaine en cours") {
        period = i18n.t("Current week");
      } else if (period === "Mois en cours") {
        period = i18n.t("This Month"); 
      } else if (period === "Le mois dernier") {
        period = i18n.t("Last Month");
      } else if (period === "Année en cours") {
        period = i18n.t("Current year");
      } else if (period === "Les 7 derniers jours") {
        period = i18n.t("The last 7 days");
      } else if (period === "Les 30 derniers jours") {
        period = i18n.t("The last 30 days");
      } else if (period === "La semaine dernière") {
        period = i18n.t("Last Week");
      } 
      else if(period === "Aujourd'hui"){
        period=i18n.t("Today")
      }
      else if (period === "Personnalisée") {
        period = i18n.t("Personalized");
      } else {
        period = i18n.t(period);
      }

      state.date = period;
    },
  },
});

export const { changePeriod, clearPeriod, translatePeriod } =
  periodSlice.actions;

export default periodSlice.reducer;
